export const DELETE_SA_QUERY_GROUP_NAME = "delete_search_analytics_query_group";
export const DELETE_SA_QUERY_GROUP_DESC = `Deletes a Search Analytics Query Group.

Use when the user asks to remove a saved query group within a Search Analytics project. Confirm the target name and project before running the mutation.

Input:
- queryGroupId (required): Query group ID to delete.
- searchAnalyticsId (optional): Parent Search Analytics ID, if known.
- projectId (optional): Project ID to help locate the group.
- name (optional): Friendly name to display when metadata cannot be fetched.

Output:
- Returns the deleted query group ID, last known metadata, and resolved project/Search Analytics IDs for navigation.

Notes:
- Write operation; always run through confirmation UI.
- If the ID is invalid or the group was already removed, return an error so the user can refresh.`;
